(() => {
  if(window.rafinedPen3DLoader)return;
  window.rafinedPen3DLoader=true;
  const active=new Map();
  function initialize(section){
    if(active.has(section))return;
    const host=section.querySelector('.rafined-3d-host'),button=section.querySelector('[data-rafined-3d-start]'),status=section.querySelector('[role="status"]');
    button.hidden=false;
    button.textContent='Explore in 3D';
    let started=false,disposeViewer,removed=false,idleId,timerId;
    const start=async()=>{
      if(started||removed)return;
      started=true;section.dataset.loading='';button.hidden=true;button.disabled=true;status.textContent='Loading the 3D pen…';host.hidden=false;
      try{
        const mount=host.shadowRoot||host.attachShadow({mode:'open'});mount.replaceChildren();
        const style=document.createElement('link');style.rel='stylesheet';style.href=new URL(section.dataset.style,location.href).href;
        const styled=new Promise((resolve,reject)=>{style.onload=resolve;style.onerror=()=>reject(new Error('Viewer stylesheet did not load'));});
        mount.append(style,section.querySelector('template').content.cloneNode(true));
        const [module]=await Promise.all([import(new URL(section.dataset.app,location.href).href),styled]);
        if(removed)return;
        disposeViewer=await module.initializePen(mount);
        if(removed){disposeViewer?.();return;}
        section.dataset.loaded='';delete section.dataset.loading;button.disabled=false;
      }catch(error){
        console.warn('RAFINED 3D viewer could not start:',error);started=false;delete section.dataset.loading;host.hidden=true;button.hidden=false;button.disabled=false;button.textContent='Try loading 3D again';status.textContent='The 3D view could not load. Try again or explore the product below.';
      }
    };
    // Load the heavy viewer only as its section approaches the viewport.
    // The existing start button also works before then and in older browsers.
    let nearViewport=false,observer;
    const queueStart=()=>{
      if(removed||started||!nearViewport)return;
      if('requestIdleCallback' in window)idleId=requestIdleCallback(start,{timeout:1200});
      else timerId=setTimeout(start,150);
    };
    const enterViewport=()=>{
      nearViewport=true;
      observer?.disconnect();
      if(document.readyState==='complete')queueStart();
      else window.addEventListener('load',queueStart,{once:true});
    };
    button.addEventListener('click',start);
    if('IntersectionObserver' in window){
      observer=new IntersectionObserver(entries=>{
        if(entries.some(entry=>entry.isIntersecting))enterViewport();
      },{rootMargin:'150px 0px',threshold:0});
      observer.observe(section);
    }
    active.set(section,()=>{
      removed=true;
      observer?.disconnect();
      window.removeEventListener('load',queueStart);
      if(idleId!==undefined)cancelIdleCallback(idleId);
      clearTimeout(timerId);
      disposeViewer?.();
      button.removeEventListener('click',start);
      active.delete(section);
    });
  }
  const scan=()=>document.querySelectorAll('[data-rafined-3d]').forEach(initialize);
  scan();document.addEventListener('shopify:section:load',scan);
  document.addEventListener('shopify:section:unload',e=>{for(const [section,dispose] of active)if(e.target.contains(section))dispose();});
})();

